//@flow

import styled from "styled-components"
import theme from "../Theme"

const Label = styled.label`
  font-weight: 500;
  font-size: 0.75rem;
  display: inline-block;
  margin-bottom: .25rem;
  text-transform: uppercase;
`

Label.defaultProps = { theme }

export default Label



// WEBPACK FOOTER //
// ./src/UI/Form/Label.js